import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
import { applyCoupen, stripePayment } from "../../Redux/actions/commonActtion";

import StripeCheckout from "react-stripe-checkout";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

import CheckoutForm from "../ProjectV2/Render/PaymentFrom";

import { Button } from "../../Components";
import SelectedPlanDetails from "./SelectedPlanDetails";
import CardDetailsForm from "./CardDetailsForm";

import { toast, ToastContainer } from "react-toastify";
import CustomToast, {
  defaultcustomToatStyle,
  customToatStyle,
} from "../../Components/CustomToast/CustomToast";

const cardDetails = {
  cardNumber: false,
  cardExpiry: false,
  cardCvc: false,
  zipcode: "",
  email: "",
};
const PaymentsDetails = ({
  setRenderOpen,

  setIsPlanShow,

  isOpen,
  setIsOpen,

  // selectedPlan,

  currentPlanDetails,
  paymentType,
  order_id,
  subscription_status,

  planPurchaseDate,
  getTime,
  remainingDays,
  expirationMessage,

  setIsSuccessOpen,
}) => {
  // console.log('2 PaymentsDetails');
  const navigate = useNavigate();
  const location = useLocation();
  // console.log(' PaymentsDetails location => ',location);
  const { selectedPlan, projectId, isCard, pathSegments } =
    location.state || {};
  // console.log('Route Location Storage projectId, isCard = ', projectId, isCard);

  const state = useSelector((state) => state.commonReducer);
  //  console.log('Redux Store selectedPlan = ',state.selectedPlan);
  const dispatch = useDispatch();
  const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);
  const [coupanName, setCoupanName] = useState("");
  const [coupanError, setCoupanError] = useState("");
  const [couponLoading, setCouponLoading] = useState("");
  const [couponDiscount, setCouponDiscount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [isDiscount100, setIsDiscount100] = useState(false);
  const [card, setCard] = useState(cardDetails);
  const user = JSON.parse(localStorage.getItem("user"));
  const [product, setProduct] = useState({
    price: selectedPlan?.price,
    name: selectedPlan?.type,
    currency: "USD",
    plan_id: selectedPlan?._id,
    user_id: user._id,
  });

  const openNewTab = () => {
    console.log(" openNewTab Fun call ");
    navigate("/paymentsuccess");
    const newTab = window.open("/paymentsuccess", "_blank");
    setTimeout(() => {
      if (newTab) {
        newTab.close();
      }
    }, 10000);
  };

  const makePayment = async (token) => {
    console.log("3 After Generate token makePayment Fun call bY token = ", token);
    try {
      setLoading(true);

      const response = await dispatch(stripePayment(token, product, coupanName));
      console.log("4 makePayment response = ", response);

      if (response?.data?.success) {
        if (response?.data?.newRecurring.stripe_status === "requires_action") {
          setLoading(false);
          return response?.data;
        } else {
          setLoading(false);
          toast(<CustomToast title={`${response?.data?.success}`} content="Payment Success"/>, defaultcustomToatStyle);
          navigate("/paymentsuccess");
          setIsOpen(false);
          setIsSuccessOpen(true);
          getTime();
          setIsOpen(false);
          setCoupanName("");
          setCoupanError("");
          setIsOpen(false);
          setCard(cardDetails);
          setRenderOpen(false);
          openNewTab();
        }
      } else if (response?.response?.data.success == false) {
        console.log("else if response?.response?.data.success = ",response?.response?.data.success);
        setCoupanName("");
        setLoading(false);
        setIsOpen(false);
        setCoupanError("");
        setIsOpen(false);
        setCard(cardDetails);
      }

      return response;
    } catch (error) {
      console.log("Catch Error = ", error);
      // toast(<CustomToast title="An error occurred" content={`${error}`} />, defaultcustomToatStyle);
      setLoading(false);
      setIsOpen(false);
      setCoupanName("");
      setIsOpen(false);
      setCard(cardDetails);
    }
  };

  const handleDiscount = async () => {
    console.log("Appy Coupon handleDiscount = ", coupanName);

    if (!coupanName) {
      setCouponDiscount(0);
      setCoupanError("Please enter a valid coupon");
      toast(<CustomToast title="" content="Please enter a valid coupon" />, defaultcustomToatStyle);
    }

    if (coupanName) {
      setCouponLoading(true);

      const response = await dispatch(applyCoupen(coupanName));
      console.log("applyCoupen API Call response = ", response);

      if (response?.data?.success) {
        console.log(" couponDiscount = ", couponDiscount);
        setCouponDiscount(response?.data?.coupans?.discount);

        if (response?.data?.coupans?.discount === 100) {
          console.log(" couponDiscount 100% = ", couponDiscount);
          setIsDiscount100(true);
        } else if (response?.data?.coupans?.discount < 100) {
          setIsDiscount100(false);
        }

        // const discountedPrice = Number(coupanName?.replace(/[^0-9]/g, ''));
        const discountedPrice = response.data.coupans.discount || 0;
        const originalPrice = selectedPlan?.price;
        const percent = discountedPrice === 100 ? 0 : originalPrice - Number((discountedPrice / 100) * originalPrice);
        // const finalPrice = originalPrice - percent

        await setProduct((prev) => ({ ...prev, price: Math.round(percent) }));

        setCoupanError("The coupon has been successfully applied.");
        setCouponLoading(false);
        toast(<CustomToast title="" content="The coupon has been successfully applied."/>, defaultcustomToatStyle);
      }

      // If data: {message: "The promotion code is not valid" , success: false}, status: 400
      if (response?.response?.data?.success === false) {
        toast(<CustomToast title="" content="The coupon you entered is either invalid or has expired."/>, defaultcustomToatStyle);
        setCoupanError("The coupon you entered is either invalid or has expired.");
        setCoupanName("");
        setProduct((prev) => ({ ...prev, price: selectedPlan?.price }));
        setCouponLoading(false);
        setCouponDiscount(0);
      }
    }
  };

  const stripeClosed = () => {
    setIsOpen(false);
    setProduct((prev) => ({ ...prev, price: selectedPlan?.price }));
    setCoupanError("");
    setCoupanName("");
  };

  const handleMakePaymentClick = () => {
    if (paymentType === 2 && subscription_status === 1) {
      setTimeout(() => {
        toast(<CustomToast title="" content="you have already subscribed please cancel subscription first."/>, customToatStyle);
      }, 100);
      return;
    } else if (isDiscount100) {
      makePayment({});
    } else {
      setIsOpen(true);
    }
  };

  const stripe = (
    <StripeCheckout
      token={makePayment}
      stripeKey={process.env.REACT_APP_STRIPE_KEY}
      name={product?.name}
      email={user?.email}
      currency="USD"
      description="Payment Description"
      amount={product?.price * 100 === 0 ? 0 : product?.price * 100}
      shippingAddress
      billingAddress
      closed={stripeClosed}
      triggerEvent="onClick"
    >
      <Button type="button" buttonStyle="btn--solid" buttonSize="btn--size">
        Pay with card
      </Button>
    </StripeCheckout>
  );

  const handleChange = (event) => {
    setCoupanName(event.target.value);
    setCoupanError("");
    setIsDiscount100(false);
    setProduct((prev) => ({
      ...prev,
      price: selectedPlan?.price,
    }));
  };

  const CloseButton = ({ closeToast }) => (
    <i className="material-icons w-7 flex justify-center cursor-pointer not-italic"  onClick={closeToast}>✖</i>
  );

  return (
    <>
      <div className="PaymentsDetails-container"
        style={{
          display: "flex",
          justifyContent: "center",
          fontFamily: "manrope",
          fontSize: "1.1rem",
          fontWeight: "bold",
          textDecoration: "none",
          color: "white",
          backgroundColor: "brown",
          padding: "0px",
        }}
      >
        <ToastContainer closeButton={CloseButton} />

        <main className="flex w-full h-full overflow-hidden shadow-2xl">

          {/* Left Section */}
          <div className="w-1/2 bg-black flex flex-col items-center justify-center text-white">
            <SelectedPlanDetails selectedPlan={selectedPlan} couponDiscount={couponDiscount} />
          </div>

          {/* Right Section */}
          <div className="w-1/2 bg-[#1e1f2a] p-6 relative flex items-center justify-center">
            <Elements stripe={stripePromise}>
              <CardDetailsForm
                setRenderOpen={setRenderOpen}               

                setIsPlanShow={setIsPlanShow} // IsUpgradeOpen={IsUpgradeOpen}

                isStripeOpen={isOpen}
                setisStripeOpen={setIsOpen}
                setIsOpen={setIsOpen}

                selectedPlan={selectedPlan}
                getTime={getTime}

                cardDetails={cardDetails}
                card={card}
                setCard={setCard}

                coupanName={coupanName}
                setCoupanName={setCoupanName}
                couponLoading={couponLoading}
                coupanError={coupanError}
                setCoupanError={setCoupanError}
                handleChange={handleChange}
                handleDiscount={handleDiscount}

                setLoading={setLoading}
                makePayment={makePayment}

                setIsSuccessOpen={setIsSuccessOpen}
                openNewTab={openNewTab}
              />
            </Elements>
          </div>
        </main>
      </div>
    </>
  );
};

export default PaymentsDetails;
